'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import UITag from '../../tag/UITag';
import SyntheticEvent from '../../core/SyntheticEvent';
import { jsx as _jsx } from "react/jsx-runtime";
export default class MultiSelectValue extends Component {
  constructor(...args) {
    super(...args);
    this.handleMouseDown = evt => {
      const {
        onClick,
        value
      } = this.props;
      if (evt.type === 'mousedown' && evt.button !== 0) {
        return;
      }
      if (onClick) {
        evt.stopPropagation();
        onClick(SyntheticEvent(value));
      }
    };
    this.handleCloseMouseDown = evt => {
      const {
        onRemove,
        value
      } = this.props;
      onRemove(value);

      // Prevent input focus, which leads to scroll jank (#1724)
      evt.preventDefault();
      evt.stopPropagation();
    };
  }
  render() {
    const {
      children,
      closeable,
      disabled,
      value
    } = this.props;
    const computedUse = value.tagUse || 'default';
    return /*#__PURE__*/_jsx(UITag, {
      _onCloseMouseDown: this.handleCloseMouseDown,
      _bordered: true,
      closeable: typeof closeable === 'boolean' ? closeable : !disabled && value.clearableValue !== false,
      onMouseDown: this.handleMouseDown,
      onTouchEnd: this.handleMouseDown,
      use: computedUse,
      children: children
    });
  }
}
MultiSelectValue.displayName = 'MultiSelectValue';
MultiSelectValue.propTypes = {
  children: PropTypes.node,
  closeable: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onRemove: PropTypes.func,
  value: PropTypes.object
};